import React from "react";
import { useTranslation } from "react-i18next";

interface SelectElementCustomInterface {
  name?: string;
  id?: string;
  value: any;
  setValue: (value: any) => void;
  options: any;
  defaultOption?: any;
  valueType?: string; // string | object
  showPrice?: boolean;
  divClass?: string;
  labelClass?: string;
}

export const SelectElementCustom: React.FC<SelectElementCustomInterface> = ({
  name,
  id,
  value,
  setValue,
  options,
  defaultOption,
  valueType = "string",
  showPrice = false,
  divClass = "",
  labelClass = "",
}) => {
  const { t } = useTranslation();

  return (
    <div className={`mb-3 ${divClass}`}>
      {name && (
        <label
          htmlFor={id}
          className={`block mb-1 text-sm font-semibold text-gray-700 ${labelClass}`}
        >
          {name}
        </label>
      )}
      <select
        id={id}
        value={valueType === "object" ? value._id : value}
        onChange={(e) => {
          const index = e.target.selectedIndex;
          valueType === "object"
            ? setValue(
                JSON.parse(e.target.options[index].getAttribute("data-element") || "")
              )
            : setValue(e.target.options[index].value);
        }}
        className="w-full px-3 py-2 rounded-md border border-gray-300 text-gray-800 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-main transition"
      >
        {defaultOption}
        {options.map((option: any) => (
          <option
            value={option._id}
            data-element={JSON.stringify(option)}
            key={option._id}
          >
            {t(option.name)}
            {showPrice && option.price ? ` - ${option.price} MRU` : ""}
          </option>
        ))}
      </select>
    </div>
  );
};
